/**
 * @module PageScrollBtn
 */

import Component from '../../base/Component';
import '../../../images/sprite/triangle.svg';
import './styles.css';

/**
 * Название компонента.
 */
export default class PageScrollBtn extends Component {
    static className = 'page-scroll-btn';
}

$(document).on('click', '.page-scroll-btn', pageScrollTop);

function pageScrollTop() {
    $('html, body').scrollTop(0);
}
